
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, HostListener, Input, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SSL_OP_MSIE_SSLV2_RSA_PADDING } from 'constants';
import { DxAutocompleteComponent, DxFormComponent, DxListComponent, DxNumberBoxComponent, DxSelectBoxComponent, DxTextBoxComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';


import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { environment } from '../../../environments/environment';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { DocxExporterService } from '../../services/docx-exporter.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { ModelliStampaService } from '../../services/modelli-stampa.service';
import { Utenteservice } from '../../services/utente.service';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
export class Alignment {
  icon: string;
  alignment: string;
  location: string;
  hint: string;
}
export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  UP_ARROW = 38,
  DOWN_ARROW = 40,
  BACKSPACE_KEY = 8
}

function isNotEmpty(value: any): boolean {
  return value !== undefined && value !== null && value !== '';
}

@Component({
  selector: 'app-edit-autocomplete',
  templateUrl: './edit-autocomplete.component.html',
  styleUrls: ['./edit-autocomplete.component.css']
})
export class EditAutocompleteComponent implements OnInit, AfterViewInit {
  @ViewChild('searchList', { static: false }) searchList: DxAutocompleteComponent;
  @ViewChild('searchList1', { static: false }) searchList1: DxAutocompleteComponent;
  @ViewChild('frmKeyId', { static: false }) frmKeyId: DxTextBoxComponent;
  @ViewChild('listBoxSearch', { static: false }) listBoxSearch: DxSelectBoxComponent;
  @ViewChild('formEditComplete', { static: false }) formEditComplete: DxFormComponent;
  @ViewChild(DxFormComponent, { static: false }) form: DxFormComponent;
  @ViewChild('dynamicInsertFormComponent', { static: false, read: ViewContainerRef }) dynamicInsertFormComponent: ViewContainerRef;



  //@ViewChild('dynamicInsertPopUp', { static: false, read: ViewContainerRef }) dynamicInsertPopUp: ViewContainerRef;

  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  // emette json {valueKey:xxxx,displayExpr:yyyyy}

  @Input() containerComponent: any; // instanza del padre
  @Input() nomeComponentRelated: any; // instanza del componente da modificare filter
  @Input() filterRelated: string = ''; // filtro da applicare al campo related
  @Input() dataFieldEmit: any = ''; // campo da passare al componente related
  
  @Input() showClearButton:boolean=true;
  @Input() remoteOperations:boolean=true;
  
  // Dati per il componente lookUp
  @Input() displayExpr: string = 'descrizione';
  @Input() labeldisplayExprPosition: string = 'left';
  
  @Input() valueExpr: any = 'id';


  //"?idSede="
  valueRelatedChange = new BehaviorSubject<any>('');



  @Input() keyRelated: string = "id";// campo da valorizzare in chiamante



  @Input() filter: string = '';
  @Input() filterRequired: boolean = true;

  @Input() defaultValueForFilter: any = '';


  @Input() api: string = 'cer';
  @Input() key: string = 'id';
  @Input() name: string = 'editcomplete';
  @Input() valueKey: any; // valore iniziale per la get
  @Input() labelKey: string = '';
  @Input() labeldisplayExpr: string = '';
  @Input() displayKey: boolean = false // Visualizza ilcampo codice
  @Input() colSpanGroup: string = "4"
  @Input() colSpanKey: number = 1
  @Input() colSpanDisplayExpr: number = 2
  @Input() required: boolean = true // valore obbligatorio

  @Input() dataField: string = 'cer' //???????
  @Input() showModalSearch:boolean=false
  @Input() grouped:boolean=false
  @Input() group:string=''
  

  filterApi
  popupComponentVisible: boolean = false
  titolo: string = ""
  searchSelected
  searchIdSelected
  elementSelected
  data: any
  passwordButton: any
  buttonEdit: any
  SelectElement: boolean = false;
  typeRicerca: string = 'contiene'
  //Accepted Values: 'contains' | 'startswith' | 'equals' | 'ge'
  mySerachMode: string = 'contains'
  //ds: CustomStore;
  alignments: Alignment[] = [
    {
      location: 'after',
      icon: 'alignjustify',
      alignment: 'contiene',
      hint: 'Contiene',

    },
    {
      location: 'after',
      icon: 'alignleft',
      alignment: 'inizia',
      hint: 'Iniza',
    },
    /*{
      location:'after',
      icon: 'aligncenter',
      alignment: 'center',
      hint: 'Center',
    },*/
    /*{
      location:'after',
      icon: 'alignright',
      alignment: 'finisce',
      hint: 'Finisce',
    },*/

  ];



  ds: DataSource;
  componentRef: any;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    //listBoxSearch
    if (event.srcElement['name'] == 'listBoxSearch') {
      if (event.keyCode === KEY_CODE.DOWN_ARROW) {

      }
    }

    //---------------------
    return;
    console.log("window ", event);
    if (event.srcElement['name'] == 'keyFind') {

      this.elementSelected = null;
      this.searchList.instance.option('value', '');

    }


    if (event.keyCode === KEY_CODE.UP_ARROW) {
      let div = ($(".dx-scrollview-content").find(".dx-list-item"));
      if (this.SelectElement == true) $(div[0]).removeClass('dx-state-active');
      this.SelectElement = false;
      console.log("Tastooooooooooooooooooo SU", event)
      // if (this.searchList.opened==false) this.searchList.opened=true
    }

    if (event.keyCode === KEY_CODE.DOWN_ARROW) {
      let div = ($(".dx-scrollview-content").find(".dx-list-item"));
      if (this.SelectElement == true) $(div[0]).removeClass('dx-state-active');
      this.SelectElement = false;
      if (this.searchList.opened == false) {
        this.searchList.opened = true;
        this.searchList.instance.focus();
        this.searchList.items[0].focus();

      }
      console.log("Tastooooooooooooooooooo GIU", event)
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
  }

  constructor(private httpClient: HttpClient,
    private _overlaySideFormService: OverlaySideFormService,
    private _overlaySidePanelService: OverlaySideFormService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private spinner: NgxSpinnerService,
    private userComponentService: ComponentService, private appService: Apiservice, private http: HttpClient, private dati: FormsTemplateService, private cdref: ChangeDetectorRef, private componentFactoryResolver: ComponentFactoryResolver,
    private activatedroute: ActivatedRoute, private docxExporterService: DocxExporterService, private httpBackend: HttpBackend, private utenteSerivce: Utenteservice, private modelliStampaService: ModelliStampaService
  ) {



    this.buttonEdit = {
      icon: "pencil",
      type: 'default',
      onClick: () => {
        this.instanceComponent('CerComponent')
      },
    };
    this.passwordButton = {
      icon: "trash",
      type: 'default',
      onClick: () => {
        this.searchIdSelected = "";
        this.searchSelected = "";
        //this.listBoxSearch.instance.repaint();
      },
    };

    const that = this;
    
    this.ds = new DataSource({
      key: this.key,
      useDefaultSearch: true,
      loadMode:'raw',
     // group: that.group,
      //paginate: true,
      //pageSize: 10,            
      onLoaded(result) {
        var items = result;
      },
      byKey(key) {
        if (key > '')
          return httpClient.get(environment.BASE_API_URL + that.api + "/" + key).toPromise().then(res => {
            if (res['items']) {
              res = res['items']
            } else {
              res = res
            }
            return res
          })
      },
      load(loadOptions: any) {
        let params: HttpParams = new HttpParams();
        [
          'skip',
          'take',
          'filter',
          'count'
        ].forEach((option) => {
          if (option in loadOptions && isNotEmpty(loadOptions[option])) {
            console.log("loadOptions[option] ", loadOptions[option])
            //$filter=contains(Location/Address, 'San Francisco')
            if (option == 'filter') {              
              try {
                let a = loadOptions[option][0][1]
                loadOptions[option][0][1] = a.replace('startswith', 'ge')
                //loadOptions[option][0][1]=a.replace('startswith','ge')
                let c = loadOptions[option][0][2]
                c = c.replace(',', '|')
                loadOptions[option][0][2] = c
              } catch (error) {
                let a = loadOptions[option][1]
                loadOptions[option][1] = a.replace('startswith', 'ge')

                let c = loadOptions[option][2]
                try {
                  if (c) c = c.replace(',', '|')
                } catch (error) {
                  //
                }
               
                loadOptions[option][2] = c
              }
            }           
            params = params.set(option, JSON.stringify(loadOptions[option]));
          }
        });
        //params = params.set('count', 'true');
        let myOrder = "$orderby=Descrizione"
        //params = params.set('$orderby', 'Descrizione');
        
        if(that.remoteOperations==false)
          params = new HttpParams();
        if (that.filterRequired && that.filterApi == '') return
        return httpClient.get(environment.BASE_API_URL + that.api + that.filterApi, { params }).toPromise().then(res => {
          if (res['items']) {
            res = res['items']
            if(Object.keys(res).length==1)
              that.searchSelected=res[0]['id'];
          } else {
            res = res
            if(Object.keys(res).length==1)
            that.searchSelected=res[0]['id'];
          }
          return res
        })
      },
    });
  }

  public inizializza(): void {
    this.api = this.data[0].dataSource
    this.key = this.data[0].key;
    this.displayExpr = this.data[0].displayExpr;
    this.labeldisplayExprPosition=this.data[0].labeldisplayExprPosition;
    this.valueKey = this.data[0].valueKey
    this.searchIdSelected = this.data[0].valueKey
    this.keyRelated = this.data[0].relatedDataField;
    this.name = this.data[0].name;
    this.filterApi=''
    this.defaultValueForFilter="";
    this.filterRequired=false;
    this.labeldisplayExpr=this.data[0].caption;
    this.outputEmit=this.data[0].eventSelect


  }



  public inizializza1(): void {

    //console.log('inizializzato ',this.data);
    this.api = this.data[0].component.dataSource
    this.key = this.data[0].component.key;
    this.displayExpr = this.data[0].component.displayExpr;
    this.valueKey = this.data[0].valueKey
    this.searchIdSelected = this.data[0].valueKey
    this.keyRelated = this.data[0].component.related[0].dataField;


  }
  ValueChanged(e) {
    console.log(e)
  }
  frmKeyIdChanged(e) {
    //alert("cambiatooooooooooooooooooooo");
    if (e.value == '') {
      this.listBoxSearch.disabled = false;
      this.searchSelected = ''
      return;
    }
//    console.log(this.listBoxSearch.instance.getDataSource()['_items']);
//    console.log("ecco ds ",this.listBoxSearch);
//    return;

    this.httpClient.get(environment.BASE_API_URL + this.api + "/" + this.searchIdSelected).toPromise().then(res => {
      console.log("frmKeyChanged " + res)
      this.searchSelected = res['id']
      //this.ds.filter(["descrizione","ge",res['descrizione']])
      this.listBoxSearch.disabled = true;
      //{valueKey:xxxx,displayExpr:yyyyy}
      let rsp = {
        valueKey: this.searchIdSelected,
        displayExpr: res[this.displayExpr],
        related: this.keyRelated,//   .data[0].component.name
        name: this.name
      }
      //console.log("ecco cosa mando ",rsp);
      this.elementSelected = rsp

      //this.searchIdSelected = e.selectedItem[this.valueExpr]
      let daEmetttere=this.searchIdSelected
      if(this.containerComponent[this.nomeComponentRelated])
        this.containerComponent[this.nomeComponentRelated].valueRelatedChange.next(daEmetttere)
      //this.outputEmit.emit(this.searchIdSelected);


     // this.outputEmit.emit(rsp);
    })
      .catch(err => {
        this.listBoxSearch.disabled = false;
        this.searchSelected = ''
        this.searchIdSelected = ''
      })



    //console.log("cambiatoooooooooooo")
    //this.elementSelected=null;
    //this.searchList.instance.option('value', '');

  }



  ngAfterViewInit(): void {
   
    //alert("1 "+this.filterRelated+" "+this.searchIdSelected);
    if(this.group)
       this.ds.group(this.group)    //.group=this.group;
       
  this.ds.load()



    if (this.searchIdSelected) {

      this.httpClient.get(environment.BASE_API_URL + this.api + "/" + this.searchIdSelected).toPromise().then(res => {
        this.searchSelected = res['id']
        this.listBoxSearch.disabled = true;
      })
        .catch(err => {
        })

    }
     
    //this.searchList.instance.registerKeyHandler('downArrowNO', function(e) {  });
  }


  itemClick(e, xx) {

    if (e.itemData.alignment == 'contiene')
      this.mySerachMode = 'contains'; else
      if (e.itemData.alignment == 'inizia')
        this.mySerachMode = 'startswith'
    //this.listBoxSearch.instance.repaint();
    //console.log("item click ",e)
  }
  ngOnInit() {
    this.filterApi = this.filter

    this.valueRelatedChange.subscribe((value) => { 
      let ciccio = "" + this.filter + value
      if (this.filterRequired) {
        if (value == '') {
          if (this.defaultValueForFilter+''>'')
            this.filterApi = this.filter +this.defaultValueForFilter
        } else
          this.filterApi = this.filter + value
      }
      else
        this.filterApi = this.filter + value

      this.searchIdSelected = "";
      this.searchSelected = "";
      if (this.filterRequired == true) {
        //this.ds.load();
        this.ds.reload();
      }
      else this.ds.load()
      //this.ds.instance._loadFunc()
      //this.currenAnnoRiferimento=value+"";
    });
  }
  onSelectionChanged(e) {
    if (e.selectedItem == null) {
      this.searchIdSelected = "";
      this.searchSelected = "";
      if(this.containerComponent[this.nomeComponentRelated])
      this.containerComponent[this.nomeComponentRelated].valueRelatedChange.next(this.searchIdSelected)
      this.outputEmit.emit(e.selectedItem);
    }
    else {
      console.log("onSelectionChanged ", e.selectedItem[this.valueExpr])
      this.searchIdSelected = e.selectedItem[this.valueExpr]
      let daEmetttere=e.selectedItem[this.dataFieldEmit]
      if(this.containerComponent && this.containerComponent[this.nomeComponentRelated])
      this.containerComponent[this.nomeComponentRelated].valueRelatedChange.next(daEmetttere)
      this.outputEmit.emit(e.selectedItem);

      //alert("wwwwwwwwwwwwwwwww");
      //this.containerComponent[this.nomeComponentRelated].filter=this.filterRelated+e.value    
      console.log(e.selectedItem)

    }

  }
  onValueChanged(e, instanceComponent) {
    return;
    this.searchIdSelected = e.value
    console.log("onValueChangedxxxxxxxx instanceComponent", instanceComponent);
    console.log("onValueChanged  containerComponent", this.containerComponent);
    console.log("onValueChanged  this", this);
    //this.valueRelatedChange
    //alert("On value change "+this.filterRelated+e.value+" "+this.nomeComponentRelated)
    this.containerComponent[this.nomeComponentRelated].valueRelatedChange.next(this.filterRelated + e.value)
    //this.containerComponent[this.nomeComponentRelated].filter=this.filterRelated+e.value

    //console.log(this.searchSelected)

  }
  onShowing(e: any) {
    //
  }
  instanceComponent(component) {

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'CerComponent');


    this._overlaySidePanelService.setTitle("Catalogo europeo rifiuti (ERR)");
    this._overlaySidePanelService.setContent(factoryClass);
    this._overlaySideFormService.setToolBarVisible(false)
    this._overlaySideFormService.setHelp("cer")
    this._overlaySideFormService.setPopupWidth(800);
    this._overlaySideFormService.setPopupHeight(500);
    //this._overlaySideFormService._hrefComponent.showTitle=false;
    let data = [
      {
        idTabRif: 0,
        nomeTabRif: "",
        dati: ""
      }
    ]
    this._overlaySidePanelService.sendDataToComponent(data);
    this._overlaySidePanelService.show();



  }
  chiudiPopup(e: any) {

    this.componentRef.clear();
    this.popupComponentVisible = false;
  }




}
